import { z } from "zod";

/**
 * A quantity arriving from an upstream source.
 *
 * Postgres NUMERIC columns come back from node-postgres as STRINGS (to preserve
 * arbitrary precision), so a socket wired to a `numeric` ingest column delivers
 * `"10.00"`, not `10`. This normalizes that to a real number before validating.
 *
 * Why `preprocess` rather than the obvious alternatives:
 *
 * - `z.union([z.number(), z.string()])` also accepts both, but the socket-type
 *   deriver (`inferSocketTypeFromZod`) only collapses a union when EVERY option
 *   is string-like — a number|string union falls through to `json`. That makes
 *   the editor accept any socket at all into a quantity. `preprocess` unwraps to
 *   its inner `z.number()`, so the socket is correctly typed `number`.
 * - `z.coerce.number()` gets the `number` socket too, but silently turns `""`
 *   and `null` into `0` — a blank source field would land as a real zero
 *   quantity. The guard below leaves those untouched so `z.number()` rejects
 *   them.
 *
 * Non-numeric strings still fail validation (`Number("abc")` is NaN, which
 * `z.number()` rejects) rather than reaching the DB.
 */
export const QUANTITY_INPUT = z.preprocess(
  (value) =>
    typeof value === "string" && value.trim() !== "" ? Number(value) : value,
  z.number(),
);
